export class DictIncorrect {
  nameField: string;
  idBoardingPass: number;
  fromBarcode: string;
  fromAODB: string;
}
